module.exports = __webpack_public_path__ + "img/user.5413af47.jpg";